import React from "react";
import TransparentModal from "../../app/UI/Modal/TransparentModal";
import { closeModal } from "./modalActions";
import { connect } from "react-redux";

import FinancialsReportSpinner from "../reports/Cachet/FinancialsReport/FinancialsReportSpinner";

const actions = {
  closeModal,
};

const financialsReportSpinnerModal = ({ closeModal }) => {
  return (
    <TransparentModal modalHeader="Please Wait...." onClose={closeModal}>
      <FinancialsReportSpinner />
    </TransparentModal>
  );
};

export default connect(null, actions)(financialsReportSpinnerModal);
